import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import '../Resources/dashboard.css';

function Usersidebar(){

     //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const logname=sessionStorage.getItem("logName00");



 useEffect(()=>{
   

  //Checking if user loggedin
  if(((logstatus==null)||(logstatus==""))&&((logid==null)||(logid==""))&&((token==null)||(token==" "))){
    window.location.replace("/login");
  }


  },[])

return(
    <>
      {/*} partial:partials/_sidebar.html */}
      <nav class="sidebar sidebar-offcanvas" id="sidebar">
        <ul class="nav">
          <li class="nav-item">
            <a href="/" class="nav-link flex-column">
           <div  /*class="nav-profile-image" */ > 
                <img src="images/logo.jpeg" alt="profile" style={{height:"9rem", width:"9rem"}} />
                {/*}change to offline or busy as needed*/}
            </div>
            {/*}  <div class="nav-profile-text d-flex ms-0 mb-3 flex-column">
                <span class="font-weight-semibold mb-1 mt-2 text-center">Sumit Enterprises</span>
                <span class="text-secondary icon-sm text-center">Id : 9887771</span>
              </div>*/}
            </a>
          </li>
        {/*  <li class="nav-item">
            <a class="nav-link d-block" href="/adminpanel-login">
            <div class="nav-profile-text d-flex ms-0 mb-3 flex-column">
            {/*}    <span class="font-weight-semibold mb-1 mt-2 text-center">Sumit Enterprises</span>
                <span class="text-secondary icon-sm text-center">Id : 9887771</span> */}
            {/*}  </div>
            </a>
          </li> */}
          <hr/>
        {/* <li class="pt-2 pb-1">
            <span class="nav-item-head">CUSTOMERS PANEL</span>
          </li> */}
        {/*}  <li class="nav-item">
          <a class="nav-link" href="">
              <i class="mdi mdi-account-multiple-outline menu-icon"></i>
              <span class="menu-title">Dashboard</span>
            </a>
          </li> */}
          <li class="nav-item">
         
     
            <a class="nav-link" href="/adminpanel-dashboard">
              <i class="mdi mdi-account-circle menu-icon"></i>
              <span class="menu-title">Dashboard</span>
            </a>
          </li>
           <li class="nav-item">
            <a class="nav-link" href="/adminpanel-teams">
              <i class="mdi mdi-account-multiple menu-icon"></i>
              <span class="menu-title">Teams</span>
            </a>
          </li>
           <li class="nav-item">
            <a class="nav-link" href="/adminpanel-teammembers">
              <i class="mdi mdi-arrange-send-backward menu-icon"></i>
              <span class="menu-title">Team Members</span>
            </a>
          </li>
           <li class="nav-item">
            <a class="nav-link" href="/adminpanel-users">
              <i class="mdi mdi-account-card-details menu-icon"></i>
              <span class="menu-title">Users</span>
            </a>
          </li>
           <li class="nav-item">
            <a class="nav-link" href="/adminpanel-all-documents">
              <i class="mdi mdi-file-chart menu-icon"></i>
              <span class="menu-title">Documents</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/adminpanel-companies">
              <i class="mdi mdi-star-circle menu-icon"></i>
              <span class="menu-title">Companies</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/adminpanel-projects">
              <i class="mdi mdi-package menu-icon"></i>
              <span class="menu-title">Projects</span>
            </a>
          </li>
       {/*}   <li class="nav-item">
            <a class="nav-link" href="/user-pickup-orders">
              <i class="mdi mdi-poll-box menu-icon"></i>
              <span class="menu-title">Pickup Requests</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/user-license-enquiry">
              <i class="mdi mdi-drawing-box menu-icon"></i>
              <span class="menu-title">License Enquiries</span>
            </a>
          </li> */}
       {/*}   <li class="nav-item">
            <a class="nav-link" href="">
              <i class="mdi mdi-cash-multiple menu-icon"></i>
              <span class="menu-title">Payments</span>
            </a>
          </li> */}
         {/* <li class="nav-item" /* hidden={customer_history_pm==0} *>
            <a class="nav-link" href="/user-support">
              <i class="mdi mdi-headset menu-icon"></i>
              <span class="menu-title">Support</span>
            </a>
          </li> */}
         
        </ul>
      </nav>
    </>

);

}

export default Usersidebar;